import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const setComparisons = createAction(
  '[View Offers] Set Comparisons',
  props<{ payload: ReplacementOffer }>()
);

export const setAllComparisons = createAction(
  '[View Offers] Set All Comparisons',
  props<{ payload: ReplacementOffer[] }>()
);

export const setDirectComparisons = createAction(
  '[View Offers] Set Direct Comparisons',
  props<{ payload: ReplacementOffer }>()
);

export const clearComparisons = createAction('[View Offers] Clear Comparisons');

export type ComparisonsActions =
  | typeof setComparisons
  | typeof clearComparisons
  | typeof setAllComparisons;
